import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  resetAll,
  resetOne,
} from '@/api/unlocatedanalysisserv'

export default {
  state: {
    state_UnlocatedAnalysis_GetAllResult: null,
    state_UnlocatedAnalysis_SearchByNameResult: null,
    state_UnlocatedAnalysis_GetPageResult: null,
    state_UnlocatedAnalysis_GetDetailResult: null,
    state_UnlocatedAnalysis_ModifyObjResult: null,
    state_UnlocatedAnalysis_DeleteObjResult: null,
    state_UnlocatedAnalysis_ResetAllResult: null,
    state_UnlocatedAnalysis_ResetOneResult: null,
  },
  mutations: {
    SET_UNLOCATEDANALYSIS_GETALL_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_GetAllResult = rst;
    },
    SET_UNLOCATEDANALYSIS_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_SearchByNameResult = rst;
    },
    SET_UNLOCATEDANALYSIS_GETPAGE_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_GetPageResult = rst;
    },
    SET_UNLOCATEDANALYSIS_GETDETAIL_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_GetDetailResult = rst;
    },
    SET_UNLOCATEDANALYSIS_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_ModifyObjResult = rst;
    },
    SET_UNLOCATEDANALYSIS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_DeleteObjResult = rst;
    },
    SET_UNLOCATEDANALYSIS_RESETALL_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_ResetAllResult = rst;
    },
    SET_UNLOCATEDANALYSIS_RESETONE_RESULT: (state, rst) => {
      state.state_UnlocatedAnalysis_ResetOneResult = rst;
    },
  },
  actions: {
    UnlocatedAnalysisServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_ResetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        resetAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_RESETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_RESETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnlocatedAnalysisServ_ResetOne({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        resetOne(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_UNLOCATEDANALYSIS_RESETONE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_UNLOCATEDANALYSIS_RESETONE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_UnlocatedAnalysis_GetAllResult: state => {
      return state.state_UnlocatedAnalysis_GetAllResult;
    },
    get_UnlocatedAnalysis_SearchByNameResult: state => {
      return state.state_UnlocatedAnalysis_SearchByNameResult;
    },
    get_UnlocatedAnalysis_GetPageResult: state => {
      return state.state_UnlocatedAnalysis_GetPageResult;
    },
    get_UnlocatedAnalysis_GetDetailResult: state => {
      return state.state_UnlocatedAnalysis_GetDetailResult;
    },
    get_UnlocatedAnalysis_ModifyObjResult: state => {
      return state.state_UnlocatedAnalysis_ModifyObjResult;
    },
    get_UnlocatedAnalysis_DeleteObjResult: state => {
      return state.state_UnlocatedAnalysis_DeleteObjResult;
    },
    get_UnlocatedAnalysis_ResetAllResult: state => {
      return state.state_UnlocatedAnalysis_ResetAllResult;
    },
    get_UnlocatedAnalysis_ResetOneResult: state => {
      return state.state_UnlocatedAnalysis_ResetOneResult;
    },
  }
}